/* eslint-disable indent */
import { AccordionSummary, Button, Grid, Input, NativeSelect, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import useStyles from '../style';
import { toast } from 'react-toastify';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { formatDateTimeToRender } from '../../../../utils/functions';
import { findPermission } from '../../../../services/auth';

const min = 0;
const max = 10;

export function BankRegister() {
  const classes = useStyles();
  const { id, idContaBancaria } = useParams();

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [isPix, setIsPix] = useState(false);

  const [getErros, setErros] = useState([]);
  const [input, setInput] = useState({});

  const [formValues, setFormValues] = useState({
    status: 'Ativo',
  });

  const [banks, setBanks] = useState([]);
  const [provider, setProvider] = useState([]);
  const [anchors, setAnchors] = useState();
  const [showDigitoAgencia, setShowDigitoAgencia] = useState(false);

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateBank = async (payload) => {
    const payloadUpadte = {
      ...payload,
      fornecedorContaBancariaId: Number(idContaBancaria),
      dataAtualizacao: input.dataAtualizacao,
    };
    try {
      const response = await api.put('FornecedoresContasBancarias', { ...payloadUpadte });
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Conta bancária alterada com sucesso!');
        setInput(response.data.resposta);
        setFormValues(response.data.resposta);
        canRenderFields();
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const createBank = async (payload) => {
    try {
      const response = await api.post('FornecedoresContasBancarias', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Conta bancária criada com sucesso!');
        setInput({});
        setFormValues({
          agencia: '',
          ancoraId: 0,
          bancoId: '0',
          cnpjCpf: '',
          conta: '',
          contaDigito: '',
          fornecedorId: 0,
          status: 'Ativo',
          agenciaDigito: ''
        });
        setInput({
          agencia: '',
          ancoraId: 0,
          bancoId: '0',
          conta: '',
          contaDigito: '',
          fornecedorId: 0,
          status: 'Ativo',
          agenciaDigito: ''
        });
        canRenderFields();
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const onSubmit = async () => {
    const payload = {
      ...input,
      ...formValues,
      ...(formValues.contaDigito && { contaDigito: formValues.contaDigito.toUpperCase() }),
      ...(formValues.ancoraId && { ancoraId: Number(formValues.ancoraId) }),
      ...(formValues.bancoId && { bancoId: Number(formValues.bancoId) }),
      ...(id && { fornecedorId: Number(id) }),
      ...(!formValues?.filialCNPJ && { cnpjCpf: provider?.cnpjCpf }),
      ...(provider.raizCNPJ &&
        provider?.filialCNPJ &&
        formValues?.filialCNPJ && { cnpjCpf: `${provider?.raizCNPJ}/${formValues?.filialCNPJ}` }),
        agenciaDigito: showDigitoAgencia ? formValues.agenciaDigito : '',
    };
    isRegister ? createBank(payload) : updateBank(payload);
  };

  const fetchExceptionById = async (id, anchorsList) => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.get(`FornecedoresContasBancarias/ConsultarId?id=${id}`);

      const redesFiltradas = anchorsList.filter(x => x.ancoraId == res.data.resposta.ancoraId)
                              
      if (redesFiltradas.length > 0 && redesFiltradas[0].obrigaDigitoAgencia == 'Sim') {
        setShowDigitoAgencia(true)
      } else {
        setShowDigitoAgencia(false)
      }

      setInput(res.data.resposta);
      setFormValues((prev) => ({ ...prev, status: res.data.resposta.status }));
      setFormValues((prev) => ({ ...prev, conta: res.data.resposta.conta }));
      setFormValues((prev) => ({ ...prev, contaDigito: res.data.resposta.contaDigito }));
      setFormValues((prev) => ({ ...prev, agenciaDigito: res.data.resposta.agenciaDigito }))

      const raizCNPJ = res.data.resposta.cnpjCpf.split('/');
      setFormValues((prv) => ({ ...prv, filialCNPJ: raizCNPJ[1] }));
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchBanks = async () => {
    const res = await api.get('Bancos/Consultar?status=Ativo');
    setBanks(res.data.resposta);
  };

  const fetchAnchors = async () => {
    const res = await api.get('Ancoras/Consultar?status=Ativo');
    setAnchors(res.data.resposta);
    return res.data.resposta
  };

  const canRenderFields = () => {
    if(input?.agenciaDigito || formValues?.agenciaDigito) {
      setShowDigitoAgencia(true)
    }

    if (input?.bancoId === 999999 && !formValues?.bancoId) {
      setIsPix(true);
      return false;
    }
    if (
      formValues?.bancoId === '999999' &&
      (formValues?.bancoId === '999999' || input?.bancoId === 999999)
    ) {
      setIsPix(true);
      return false;
    }
    if (
      formValues?.bancoId === 999999 &&
      (formValues?.bancoId === 999999 || input?.bancoId === 999999)
    ) {
      setIsPix(true);
      return false;
    }
    setIsPix(false);
    return true;
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    if (res.data.resposta.cnpjCpf.length >= 15) {
      const raizCNPJ = res.data.resposta.cnpjCpf.split('/');
      setFormValues((prv) => ({ ...prv, cnpjCpf: raizCNPJ[1] }));
      return setProvider({
        ...res.data.resposta,
        raizCNPJ: raizCNPJ[0],
        filialCNPJ: raizCNPJ[1],
      });
    }
    setProvider(res.data.resposta);
  };

  useEffect(() => {
    canRenderFields();
  }, [formValues?.bancoId, provider?.bancoId, input?.bancoId]);

  useEffect(() => {
    const initialize = async () => {
      await fetchBanks();
      await fetchProvider();
      const anchorsList = await fetchAnchors();
      if (window.location.pathname.includes('cadastrar')) {
        setLoading(false);
        setIsEditing(true);
        setIsRegister(true);
        return;
      }
      if (idContaBancaria) {
        setIsEditing(window.location.pathname.includes('editar'));
        await fetchExceptionById(idContaBancaria, anchorsList);
        return;
      }
      setIsEditing(false);
      setIsRegister(false);
    };
    initialize();
  }, [idContaBancaria]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} conta bancária do fornecedor - ${
            provider?.nomeFantasia || ''
          }`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando conta bancária do fornecedor - ${provider?.nomeFantasia ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={(event) => {
                              handleInputChange(event, event.target.value)
                              const redesFiltradas = anchors.filter(x => x.ancoraId == event.target.value)
                              
                              if (redesFiltradas.length > 0 && redesFiltradas[0].obrigaDigitoAgencia == 'Sim') {
                                setShowDigitoAgencia(true)
                              } else {
                                setFormValues((prev) => ({
                                  ...prev,
                                  agenciaDigito: ''
                                }))
                                setInput((prev) => ({
                                  ...prev,
                                  agenciaDigito: ''
                                }))
                                setShowDigitoAgencia(false)
                              }
                            }}
                            className={classes.input}
                            value={formValues?.ancoraId || input?.ancoraId}
                            name="ancoraId"
                            disabled={!isEditing && !isRegister}
                            onBlur={(event) =>
                              getErros.includes('AncoraId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'AncoraId';
                                }),
                              )
                            }
                            error={getErros.includes('AncoraId')}
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {anchors?.map((anchor) => (
                              <option key={anchor.ancoraId} value={anchor.ancoraId}>
                                {anchor.nomeFantasia}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            disabled={!isEditing}
                            className={classes.input}
                            value={formValues?.status || input?.status}
                            name="status"
                            onChange={handleInputChange}
                            error={getErros.includes('Status')}
                            onBlur={(event) =>
                              getErros.includes('Status') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Status';
                                }),
                              )
                            }
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      {provider?.tipoPessoa !== 'Juridica' ? (
                        <Grid item xs={isEditing ? 2 : 3}>
                          <label className={classes.label}>CPF</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="999.999.999-99"
                              value={formValues?.cnpjCpf || provider?.cnpjCpf || input?.cnpjCpf}
                              disabled
                              name="cnpjCpf"
                              onChange={handleInputChange}
                              error={getErros.includes('CnpjCpf')}
                              onBlur={(event) =>
                                getErros.includes('CnpjCpf') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'CnpjCpf';
                                  }),
                                )
                              }
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  placeholder="CPF"
                                  disabled
                                  name="cnpjCpf"
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      ) : !isEditing ? (
                        <Grid item xs={3}>
                          <label className={classes.label}>CNPJ</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="99.999.999/9999-99"
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              disabled
                              placeholder="CNPJ"
                              value={input?.cnpjCpf || provider?.cnpjCpf}
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  placeholder="CPF"
                                  disabled
                                  name="cnpjCpf"
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      ) : (
                        <Grid item xs={2}>
                          <label className={classes.label}>CNPJ</label>
                          <div className={classes.cnpjBox}>
                            <Paper className={classes.medium} elevation={0}>
                              <InputMask
                                mask="99.999.999/"
                                className={classes.input}
                                value={provider?.raizCNPJ}
                                error={getErros.includes('CnpjCpf')}
                                onBlur={(event) =>
                                  getErros.includes('CnpjCpf') &&
                                  setErros(
                                    getErros.filter(function (item) {
                                      return item !== 'CnpjCpf';
                                    }),
                                  )
                                }
                                disabled
                              >
                                {() => <Input className={classes.input} />}
                              </InputMask>
                            </Paper>
                            <Paper
                              className={classes.medium}
                              elevation={0}
                              style={{ width: '100%' }}
                            >
                              <InputMask
                                mask="9999-99"
                                className={classes.input}
                                disabled={!isEditing}
                                placeholder="CNPJ"
                                name="filialCNPJ"
                                onChange={(e) =>
                                  setFormValues((prev) => ({
                                    ...prev,
                                    filialCNPJ: e.target.value,
                                  }))
                                }
                                value={formValues?.filialCNPJ || provider?.filialCNPJ}
                                error={getErros.includes('CnpjCpf')}
                                onBlur={(event) =>
                                  getErros.includes('CnpjCpf') &&
                                  setErros(
                                    getErros.filter(function (item) {
                                      return item !== 'CnpjCpf';
                                    }),
                                  )
                                }
                              >
                                {() => <Input className={classes.input} />}
                              </InputMask>
                            </Paper>
                          </div>
                        </Grid>
                      )}

                      <Grid item xs={isEditing ? 4 : 3}>
                        <label className={classes.label}>Banco</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={(e) => {
                              e.target.value === '999999'
                                ? setFormValues((prev) => ({
                                    ...prev,
                                    bancoId: e.target.value,
                                    agencia: '',
                                    conta: '',
                                    contaDigito: '',
                                    agenciaDigito: ''
                                  }))
                                : setFormValues((prev) => ({ ...prev, bancoId: e.target.value }));
                            }}
                            className={classes.input}
                            value={formValues?.bancoId || input?.bancoId}
                            name="bancoId"
                            disabled={!isEditing && !isRegister}
                            error={getErros.includes('BancoId')}
                            onBlur={(event) =>
                              getErros.includes('BancoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'BancoId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {banks?.map((bank) => (
                              <option key={bank.bancoId} value={bank.bancoId}>
                                {bank.banco}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      {!isPix && (
                        <Grid item xs={1}>
                          <label className={classes.label}>Agência</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="9999"
                              value={formValues?.agencia || input?.agencia}
                              name="agencia"
                              onChange={(e) => {
                                setFormValues((prev) => ({ ...prev, agencia: e.target.value }));
                              }}
                              disabled={!isEditing}
                              error={getErros.includes('Agencia')}
                              onBlur={() => {
                                if (!formValues?.agencia) {
                                  setErros((prev) => [...prev, 'Agencia']);
                                } else {
                                  getErros.includes('Agencia') &&
                                    setErros(getErros.filter((item) => item !== 'Agencia'));
                                }
                              }}
                            >
                              {() => (
                                <Input
                                  placeholder="Agência"
                                  className="input-select"
                                  name="agencia"
                                  disabled={!isEditing}
                                  style={{ height: '42px' }}
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      )}

                      {(!isPix && showDigitoAgencia) ? (
                        <Grid item xs={1}>
                          <label className={classes.label}>Digito</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important', height: '42px' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              placeholder="Digito da Agencia"
                              maxLength={1}
                              onChange={(e) => {
                                setFormValues({
                                  ...formValues,
                                  agenciaDigito: e.target.value,
                                });
                              }}
                              value={formValues?.agenciaDigito}
                              disabled={!isEditing}
                              name="agenciaDigito"
                              error={getErros.includes('Digito da Agencia')}
                              onBlur={(event) =>
                                getErros.includes('Digito da Agencia') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'Digito da Agencia';
                                  }),
                                )
                              }
                              inputProps={{
                                minLength: 1,
                                maxLength: 1,
                                style: { textTransform: "uppercase" }
                              }}
                            />
                          </Paper>
                        </Grid>
                      ) : (<></>)}

                      {!isPix && (
                        <Grid item xs={2}>
                          <label className={classes.label}>Conta</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important', height: '42px' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              value={formValues?.conta}
                              placeholder="Conta"
                              maxLength={20}
                              onChange={(e) => {
                                setFormValues({ ...formValues, conta: e.target.value });
                                // const re = /^[-.0-9\b]+$/;
                                // if (e.target.value === '' || re.test(e.target.value)) {
                                //   setFormValues({ ...formValues, conta: e.target.value });
                                // }
                              }}
                              disabled={!isEditing}
                              name="conta"
                              error={getErros.includes('Conta')}
                              onBlur={(event) =>
                                getErros.includes('Conta') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'Conta';
                                  }),
                                )
                              }
                              inputProps={{
                                minLength: 2,
                                maxLength: 20,
                              }}
                            />
                          </Paper>
                        </Grid>
                      )}
                      {!isPix && (
                        <Grid item xs={1}>
                          <label className={classes.label}>Digito</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              style={{ textTransform: 'uppercase !important', height: '42px' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              placeholder="Digito da conta"
                              maxLength={2}
                              onChange={(e) => {
                                setFormValues({
                                  ...formValues,
                                  contaDigito: e.target.value,
                                });
                              }}
                              value={formValues?.contaDigito}
                              disabled={!isEditing}
                              name="contaDigito"
                              error={getErros.includes('Digito da conta')}
                              onBlur={(event) =>
                                getErros.includes('Digito da conta') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'Digito da conta';
                                  }),
                                )
                              }
                              inputProps={{
                                minLength: 1,
                                maxLength: 2,
                                style: { textTransform: "uppercase" }
                              }}
                            />
                          </Paper>
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                input.dataRegistro && formatDateTimeToRender(input.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                input.dataAtualizacao
                                  ? formatDateTimeToRender(input.dataAtualizacao)
                                  : input.dataAtualizacao
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {(isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant="contained"
                      type="button"
                      onClick={onSubmit}
                      className={classes.button}
                    >
                      {isRegister ? 'Cadastrar' : 'Atualizar'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
